import React from "react";
import "./Price.css";
import leftEllipise from "../assets/left-ellipse.png";
import Dialog from "@mui/material/Dialog";
import ContactDialog from "../components/Contact-Dialog";
import useSendEmail from "../hooks/use-send-email.ts"; // Import the custom hook
import { toast } from "react-toastify";
import logo from "../assets/logo.svg";

export const Price = () => {
  const [open, setOpen] = React.useState(false);
  const { sendEmail, loading, error } = useSendEmail(); // Destructure the hook's return values

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = async (formData) => {
    const success = await sendEmail(formData);
    if (success) {
      setOpen(false);
      toast.success(
        "Thank you for your inquiry. We will get back to you as soon as possible!"
      );
    } else {
      // Optionally, handle errors here, such as showing an error message to the user
      toast.error("An error occurred, please try again.");
      console.error("Failed to send email:", error);
    }
  };

  const getDialogWidth = () => {
    const viewportWidth = window.innerWidth;
    if (viewportWidth <= 800) {
      return "100vw"; // Full width on small screens
    } else if (viewportWidth < 1100) {
      return `${viewportWidth}px`; // Use viewport width if less than 1100px
    }
    return "1100px"; // Default width for larger screens
  };

  return (
    <div id="Price">
      <div className="price-container container">
        {<img alt="logo" className="logo" src={logo} />}
        <div className="ellipse-container">
          <img alt="left ellipse" className="left-ellipse" src={leftEllipise} />
        </div>

        <h1 className="pricing">Price</h1>

        <ul>
          <li>
            <p>Ballet for children:</p>
            <p>
              membership for 4 classes per month - <span>$90</span>
            </p>
            <p>
              membership for 8 classes per month - <span>$170</span>
            </p>
            <p>
              one session - <span>$32</span>
            </p>
          </li>

          <li>
            <p>
              Functional personal training for adults or teens -{" "}
              <span>$60-$100</span>
            </p>
          </li>

          <li>
            <p>Functional training in a group for adults or teens:</p>
            <p>
              membership for 4 workouts per month - <span>$100</span>
            </p>
            <p>
              membership for 8 training sessions per month - <span>$170</span>
            </p>
            <p>
              one session - <span>$32</span>
            </p>
          </li>

          <p className="subtext">
            *If you buy a membership, the 5th training session as a gift.
          </p>
        </ul>

        <button className="book-now" onClick={handleClickOpen}>
          Book Now
        </button>
      </div>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth={getDialogWidth()}
        minwidth={"400px"}
      >
        <ContactDialog
          onSubmit={(formData) => {
            handleClose(formData);
          }}
          onClose={() => setOpen(false)}
        />
      </Dialog>
    </div>
  );
};

export default Price;
